import { getItem, setItem } from "Common/localStorage/utils";
import Close from "Components/close";
import classNames from "classnames";
import React, { memo, useCallback, useState } from "react";
import { MODE, MODE_ICONS, localStorageHideHintMessageKey } from "../constants";
import locale from "./modeHintMessage.locale";
function ModeHintMessage(props) {
    const [hideHintMessage, setHideHintMessage] = useState(() => Boolean(getItem(localStorageHideHintMessageKey)));
    const handleHintModeMessageHide = useCallback(() => {
        setHideHintMessage(true);
        setItem(localStorageHideHintMessageKey, 1);
    }, []);
    if (hideHintMessage || !props.mode || props.mode === MODE.VIEW)
        return null;
    return (React.createElement("div", { className: classNames(props.className, "pl-1 pr-1 pt-0_75 pb-0_75 font-base  notify-info-bg notify-info-border border-rounded-medium") },
        React.createElement("div", { className: "grid-cols-1fr-auto v-center-items with-gap-12 font-base" },
            React.createElement("div", { className: "line-height-1 d-flex v-center-items text-sys-light-on-surface fw-6" },
                React.createElement("i", { className: classNames(MODE_ICONS[props.mode], "font-h5 mr-0_5 notify-info-icon v-align-bottom") }),
                React.createElement("span", { className: "v-align-text-top mr-0_25" }, locale.PLEASE_PRESS_ESC),
                React.createElement("span", { className: "v-align-text-top" }, locale.FOR_ESCAPE_FROM_MODE)),
            React.createElement(Close, { className: "text-gray-400", fontSize: 14, onClick: handleHintModeMessageHide })),
        (props.mode === MODE.ADDING_LOCATION_LINE || props.mode === MODE.ADDING_LOCATION_AREA) && (React.createElement("div", { className: "text-sys-light-on-surface mt-0_5" }, props.mode === MODE.ADDING_LOCATION_LINE
            ? locale.ADDING_LOCATION_LINE_HINT
            : locale.ADDING_LOCATION_AREA_HINT))));
}
export default memo(ModeHintMessage);
